import { EntityFormController } from "../types/controllers"
import { calculateDv } from "../pure/utils"

// Connects to data-controller="entities-form"
export default class extends EntityFormController {
  connect() {
    [ this.documentNumberInputTarget, this.isTaxpayerCheckboxTarget ].forEach((element) => {
      element.addEventListener("change", () => this.updateDvSpan())
      element.addEventListener("input", () => this.updateDvSpan())
    })
    this.updateDvSpan()
  }


  updateDvSpan() {
    if (this.isTaxpayerCheckboxTarget.checked) {
      const documentNumber = this.documentNumberInputTarget.value
      const dv = calculateDv(documentNumber)
      this.dvSpanTarget.textContent = `- ${dv}`
      this.dvSpanTarget.classList.remove("hidden")
    } else {
      this.dvSpanTarget.classList.add("hidden")
    }
  }
}
